import React, { useContext } from 'react';
import Icon from '../Icon';
import { LoadingIcon } from '../Icons';
import { ThemeContext } from 'styled-components';
import { LoadingWrapper } from './style';
var LoadingIndicator = function LoadingIndicator(props) {
  var themeContext = useContext(ThemeContext);
  var className = props.className,
    _props$fullHeight = props.fullHeight,
    fullHeight = _props$fullHeight === void 0 ? false : _props$fullHeight,
    _props$size = props.size,
    size = _props$size === void 0 ? 'sz32' : _props$size,
    _props$color = props.color,
    color = _props$color === void 0 ? themeContext.colors.text.secondary : _props$color,
    _props$testId = props.testId,
    testId = _props$testId === void 0 ? 'loading-indicator' : _props$testId;
  return /*#__PURE__*/React.createElement(LoadingWrapper, {
    className: className,
    fullHeight: fullHeight,
    "data-testid": testId
  }, /*#__PURE__*/React.createElement(Icon, {
    as: LoadingIcon,
    size: size,
    color: color
  }));
};
LoadingIndicator.displayName = 'LoadingIndicator';
export default LoadingIndicator;